import DataTableTitle from "../../DataTableComponents/DataTableTitle";

const AbsenBulananColumns = (dateList) => {
  return [
    {
      name: <DataTableTitle text={"Nama Staf"} />,
      selector: (row) => row.nama,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Grup Staf"} />,
      selector: (row) => row.group_staf,
      sortable: true,
      wrap: true,
    },
    ...dateList.map((date) => {
      const today = new Date(date.tanggal);
      return {
        name: <DataTableTitle text={today.getDate()} />,
        selector: (row) => {
          const rekap = row.rekap_absensi[today.getDate() - 1];
          return (
            // H = Hadir
            // A = Alfa
            // PSW = Pulang Sebelum Waktunya (Contoh: sebelum 16:00)
            // TLD = Terlambat Datang (Contoh: setelah 08:00)
            rekap?.jumlah_a > 0 ? (
              <div>Alfa</div>
            ) : (
              rekap?.jumlah_h > 0 && (
                <div className="row">
                  <div>Hadir</div>
                  {rekap?.jumlah_tld > 0 && <small>TLD</small>}
                  {rekap?.jumlah_psw > 0 && <small>PSW</small>}
                </div>
              )
            )
            // <div className="row">
            //   <small>H: {rekap?.jumlah_h || 0}</small>
            //   <small>A: {rekap?.jumlah_a || 0}</small>
            //   <small>PSW: {rekap?.jumlah_psw || 0}</small>
            //   <small>TLD: {rekap?.jumlah_tld || 0}</small>
            // </div>
          );
        },
        wrap: true,
      };
    }),
    {
      name: <DataTableTitle text={"Total"} />,
      selector: (row) => {
        const totalRekap = row.rekap_absensi?.reduce(
          (accumulator, item) => {
            return {
              jumlah_h: accumulator.jumlah_h + (item?.jumlah_h || 0),
              jumlah_a: accumulator.jumlah_a + (item?.jumlah_a || 0),
              jumlah_psw: accumulator.jumlah_psw + (item?.jumlah_psw || 0),
              jumlah_tld: accumulator.jumlah_tld + (item?.jumlah_tld || 0),
            };
          },
          {
            jumlah_h: 0,
            jumlah_a: 0,
            jumlah_psw: 0,
            jumlah_tld: 0,
          }
        );

        return (
          <div className="row">
            <small>H: {totalRekap?.jumlah_h}</small>
            <small>A: {totalRekap?.jumlah_a}</small>
            <small>PSW: {totalRekap?.jumlah_psw}</small>
            <small>TLD: {totalRekap?.jumlah_tld}</small>
          </div>
        );
      },
      wrap: true,
    },
  ];
};

export default AbsenBulananColumns;
